module.exports = __webpack_public_path__ + "assets/img/9.3dd59a55.png";